import { genUUIDv4 } from '../../../scripts/util/uuid';

// INIT
const DEBUG = true;
const BOOKING_SUCCESS_PAGE = 'pages/kvittering-booking';
const PROGRAM_ID = '8075';

checkPartnerReferral();
if (isCorrectPage(BOOKING_SUCCESS_PAGE)) sendToPartner(); // called only on booking success page
// END INIT

function isCorrectPage(page) {
    return document.URL.includes(page);
}

function checkPartnerReferral() {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const paID = urlParams.get('paid');
    const pacID = urlParams.get('pacid');

    if (!paID || !pacID) {
        return;
    }

    clearCookie("_paid");
    clearCookie("_pacid");

    const nowDateTime = new Date().addDays(40);
    setCookie("_paid", paID, nowDateTime);
    setCookie("_pacid", pacID, nowDateTime);
}

function setCookie(name, value, expiryDate) {
    const expires = "expires=" + expiryDate.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + "; path=/";
}

function clearCookie(name) {
    if(getCookie(name)) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}

function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}

function sendToPartner() {
    const paID = getCookie("_paid");
    const pacID = getCookie("_pacid");

    DEBUG && console.warn("[INFO] On booking success page");
    DEBUG && console.log(`https://www.partner-ads.com/dk/leadtracks2s.php?programid=${PROGRAM_ID}&type=lead&partnerid=${paID}&pacid=${pacID}&uiv=${genUUIDv4()}`);

    if (!getCookie("_paid") || !getCookie("_pacid")) {
        DEBUG && console.warn("[WARN] No paid and no pacid cookies");
        return;
    }

    fetch(`https://www.partner-ads.com/dk/leadtracks2s.php?programid=${PROGRAM_ID}&type=lead&partnerid=${paID}&pacid=${pacID}&uiv=${genUUIDv4()}`)
        .then((resp) => {
            resp.json();
        }).then((data) => {
            DEBUG && console.log(data);
        })
}